import { useDisplayUnits } from 'state/displayUnits/context';
import { displayUnitsCustomEventsBindingSelector } from 'state/selectors';
import { useWidget } from 'state/widget/context';

export default function useDisplayUnitsCustomEventBindings() {
  const { state: widgetState } = useWidget();
  const displayUnitsState = useDisplayUnits();
  return displayUnitsCustomEventsBindingSelector(
    widgetState,
    displayUnitsState,
  );
}
